import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ALLOWED_STATUSES_FOR_TICKET_FILTER } from '../../../../constants/accountStatuses';
import {
  changeSelectedBusinessesForAllFilter,
  changeSelectedBusinessBrandOptionsForAllFilter,
} from '../../../../actions/allFilterActions';
import { setBusinessesDetailsSearchParamsAndLoad } from '../../../../actions/businessActions';

export const useBusinessFilters = ({ businessBrandOptions, selectedBusinessBrandOptionsList }) => {
  const dispatch = useDispatch();
  const [showBusinessFilter, setShowBusinessFilter] = useState(true);

  const onBusinessSelectFilterValuesChangedHandler = useCallback(
    (optionList) => {
      const selectedSMBIdList = optionList.map((option) => option.value);
      dispatch(changeSelectedBusinessesForAllFilter(selectedSMBIdList));

      if (selectedSMBIdList.length === 0) {
        dispatch(changeSelectedBusinessBrandOptionsForAllFilter([]));
      } else if (selectedBusinessBrandOptionsList.length > 0) {
        dispatch(changeSelectedBusinessBrandOptionsForAllFilter(selectedBusinessBrandOptionsList));
      }
    },
    [dispatch, selectedBusinessBrandOptionsList]
  );

  const onBusinessSelectInputChange = useCallback(
    async (inputValue) => {
      await dispatch(setBusinessesDetailsSearchParamsAndLoad(inputValue, ALLOWED_STATUSES_FOR_TICKET_FILTER));
    },
    [dispatch]
  );

  const onBusinessBrandOptionsSelectInputChange = useCallback(
    async (inputValue) => {
      await dispatch(setBusinessesDetailsSearchParamsAndLoad(inputValue, ALLOWED_STATUSES_FOR_TICKET_FILTER));
    },
    [dispatch]
  );

  const onBusinessBrandOptionsSelectFilterValuesChangedHandler = useCallback(
    (optionList) => {
      dispatch(changeSelectedBusinessBrandOptionsForAllFilter(optionList));
    },
    [dispatch]
  );

  const formatBusinessBrandOptionsNames = useCallback(() => {
    if (!businessBrandOptions) {
      return [];
    }
    const brandOptionsValues = Object.values(businessBrandOptions);
    const uniqueBrandOptions = Array.from(new Set(brandOptionsValues));
    const formatBrandOptions = uniqueBrandOptions.map((value) => ({
      value: value,
      label: value,
    }));

    return formatBrandOptions.sort((a, b) => (a.value > b.value ? 1 : -1));
  }, [businessBrandOptions]);

  const onToggleBusinessFilterHandler = useCallback(() => {
    setShowBusinessFilter((prev) => !prev);
  }, []);

  return {
    showBusinessFilter,
    onBusinessSelectFilterValuesChangedHandler,
    onBusinessSelectInputChange,
    onBusinessBrandOptionsSelectInputChange,
    onBusinessBrandOptionsSelectFilterValuesChangedHandler,
    formatBusinessBrandOptionsNames,
    onToggleBusinessFilterHandler,
  };
};
